import { News } from "../models/strapi/news-model";
import { UsefulLink } from "../models/strapi/useful-link-model";
import { Document } from "../models/strapi/document-model";
import { Advice } from "../models/strapi/advice-model";
const config = useRuntimeConfig();
export const advice = {
  useUsefulLinks: createUseApi<
    {
      locale: string;
    },
    {
      data: UsefulLink[];
    }
  >({
    method: "GET",
    url: `${config.public.url}/useful-links`,
    queryBuilder: plainQueryBuilder,
    attachXLocaleHeader: false,
  }),
  useNews: createUseApi<
    { slug: string } | void,
    {
      data: News[];
    }
  >({
    method: "GET",
    url: `${config.public.url}/news`,
    attachXLocaleHeader: false,
    queryBuilder: (input) => {
      const query: Record<string, string | string[]> = {
        locale: "pl",
        populate: ["image"],
      };

      if (typeof input === "object") {
        query["filters[slug][$eq]"] = input.slug;
      }

      return query;
    },
  }),
  useDocuments: createUseApi<
    void,
    {
      data: Document[];
    }
  >({
    method: "GET",
    url: `${config.public.url}/documents`,
    attachXLocaleHeader: false,
    queryBuilder: () => {
      // const { locale } = useI18n();
      return {
        // used to be this way without useI18n idk
        // @TODO ?
        // locale,
        locale: "pl",
        populate: ["file"],
      };
    },
  }),
  useAdviceList: createUseApi<
    void,
    {
      data: Advice[];
    }
  >({
    method: "GET",
    url: `${config.public.url}/advice`,
    attachXLocaleHeader: false,
    queryBuilder: () => {
      // const { locale } = useI18n();
      return {
        // used to be this way without useI18n idk
        // @TODO ?
        // locale,
        locale: "pl",
        // populate: ["file"],
      };
    },
  }),
};
